module.exports = __webpack_public_path__ + "static/img/product_banner_11_zh.8f1d8f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_11_zh.png
// module id = xZjQ
// module chunks = 34